import styles from './VMainPartners.module.css'
import VMainTitle from "../VMainTitle"

// LOGOS
// import LogoBeeline from '../../../assets/img/logo/partners/beeline.png'
// import LogoDanone from '../../../assets/img/logo/partners/danone.png'
// import LogoEurasian from '../../../assets/img/logo/partners/eurasian.png'
// import LogoForte from '../../../assets/img/logo/partners/forte.png'
// import LogoDhl from '../../../assets/img/logo/partners/dhl.png'
// import LogoKbtu from '../../../assets/img/logo/partners/kbtu.png'
// import LogoSokol from '../../../assets/img/logo/partners/sokol.png'


import logo_abdiibrahim from '../../../assets/img/logo/partners/abdiibrahim.svg'
import logo_arbuz_freedomHoldingGroup from '../../../assets/img/logo/partners/arbuz_freedomHoldingGroup.svg'
import logo_beeline from '../../../assets/img/logo/partners/beeline.svg'
import logo_chevron from '../../../assets/img/logo/partners/chevron.svg'
import logo_danone from '../../../assets/img/logo/partners/danone.svg'
import logo_dhl from '../../../assets/img/logo/partners/dhl.svg'
import logo_eurFilmMarket from '../../../assets/img/logo/partners/eurFilmMarket.svg'
import logo_eurasianBank from '../../../assets/img/logo/partners/eurasianBank.svg'
import logo_foodMaster from '../../../assets/img/logo/partners/foodMaster.svg'


import logo_henkel from '../../../assets/img/logo/partners/henkel.svg'
import logo_jacobs from '../../../assets/img/logo/partners/jacobs.svg'
import logo_kbtu from '../../../assets/img/logo/partners/kbtu.svg'
import logo_kimep from '../../../assets/img/logo/partners/kimep.svg'
import logo_oriflame from '../../../assets/img/logo/partners/oriflame.svg'
import logo_siemens from '../../../assets/img/logo/partners/siemens.svg'
import logo_sokol from '../../../assets/img/logo/partners/sokol.svg'
import logo_toimart from '../../../assets/img/logo/partners/toimart.svg'
import logo_zhailjau from '../../../assets/img/logo/partners/zhailjau.svg'


const Box = ({ title }) => {
    return(
                <div className={"card__wrapper " + styles.card__wrapper}>
                    <div className={"card__content " + styles.card}>
                        <h3>{title}</h3>
                        <button>Подробнее</button>
                        <button>В корзину</button>
                    </div>
                </div>
    )
}


const VMainPartners = () => {
  return (
    <>
        <section className={styles.partners}>
        <VMainTitle title='Компании которые доверяют нам' subtitle='Завод “Calipso” на рынке с 1997, и за это время заслужило доверие компаний:'/>
            <div className={styles.partners_wrapper}>

                

            <div className={styles.slider}>
                <div className={styles.slide__track_1}>
                    {/* <div className={styles.slide}><img src={LogoBeeline} alt="Bottle" /></div> */}
                    
                    <img className={styles.slide} src={logo_henkel} alt="Henkel" />
                    <img className={styles.slide} src={logo_jacobs} alt="Jacobs" />
                    <img className={styles.slide} src={logo_kbtu} alt="KBTU" />
                    <img className={styles.slide} src={logo_kimep} alt="Kimep" />
                    <img className={styles.slide} src={logo_oriflame} alt="Oriflame" />
                    <img className={styles.slide} src={logo_siemens} alt="Siemens" />
                    <img className={styles.slide} src={logo_sokol} alt="Sokol" />
                    <img className={styles.slide} src={logo_toimart} alt="Toimart" />
                    <img className={styles.slide} src={logo_zhailjau} alt="Zhailjau" />

                    <img className={styles.slide} src={logo_henkel} alt="Henkel" />
                    <img className={styles.slide} src={logo_jacobs} alt="Jacobs" />
                    <img className={styles.slide} src={logo_kbtu} alt="KBTU" />
                    <img className={styles.slide} src={logo_kimep} alt="Kimep" />
                    <img className={styles.slide} src={logo_oriflame} alt="Oriflame" />
                    <img className={styles.slide} src={logo_siemens} alt="Siemens" />
                    <img className={styles.slide} src={logo_sokol} alt="Sokol" />
                    <img className={styles.slide} src={logo_toimart} alt="Toimart" />
                    <img className={styles.slide} src={logo_zhailjau} alt="Zhailjau" />
                </div>
            </div>

            <div className={styles.slider}>
                <div className={`${styles.slide__track_2} ${styles.reverse}`}>
                    
                    <img className={styles.slide} src={logo_abdiibrahim} alt="Abdi Ibrahim" />
                    <img className={styles.slide} src={logo_arbuz_freedomHoldingGroup} alt="Arbuz Freedom Holding Group" />
                    <img className={styles.slide} src={logo_beeline} alt="Beeline" />
                    <img className={styles.slide} src={logo_chevron} alt="Chevron" />
                    <img className={styles.slide} src={logo_danone} alt="Danone" />
                    <img className={styles.slide} src={logo_dhl} alt="DHL" />
                    <img className={styles.slide} src={logo_eurFilmMarket} alt="Eurasian Film Market" />
                    <img className={styles.slide} src={logo_eurasianBank} alt="Eurasian Bank" />
                    <img className={styles.slide} src={logo_foodMaster} alt="Food Master" />
                    
                    
                    <img className={styles.slide} src={logo_abdiibrahim} alt="Abdi Ibrahim" />
                    <img className={styles.slide} src={logo_arbuz_freedomHoldingGroup} alt="Arbuz Freedom Holding Group" />
                    <img className={styles.slide} src={logo_beeline} alt="Beeline" />
                    <img className={styles.slide} src={logo_chevron} alt="Chevron" />
                    <img className={styles.slide} src={logo_danone} alt="Danone" />
                    <img className={styles.slide} src={logo_dhl} alt="DHL" />
                    <img className={styles.slide} src={logo_eurFilmMarket} alt="Eurasian Film Market" />
                    <img className={styles.slide} src={logo_eurasianBank} alt="Eurasian Bank" />
                    <img className={styles.slide} src={logo_foodMaster} alt="Food Master" />           
                </div>
            </div>

             


                
            </div>
        </section>
    </>
  )
}

export default VMainPartners